// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2e7d3504","453":"8c6b12bc","455":"c0bf9a0c","644":"4f499ccb"}[chunkId] + ".chunk.js";
};